import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { IndustryBuilderGuard } from "@/components/auth/IndustryBuilderGuard";
import ConstructionProposalBuilder from "@/pages/ConstructionProposalBuilder";
export const Route = createFileRoute("/construction-builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><IndustryBuilderGuard industry="construction-services"><ConstructionProposalBuilder /></IndustryBuilderGuard></ProtectedRoute>) });
